/* cued: Gratis-Sealer automatisch in den Warenkorb legen, sobald ein Starterkit oder
   die Toolbox drin ist. v3: eigenes 0-EUR-Produkt "SEALER (Gratis)" statt Rabatt,
   damit Affiliate-/Creator-Codes weiter auf Kit & Toolbox greifen.
   Gratis-Sealer max. 1x, wird entfernt, wenn kein Starterkit/Toolbox mehr im Warenkorb ist.
   v4 (02.11.): gleiche Regel fuer Landingpages (Checkout-Permalinks /cart/<ids>). */
(function () {
  if (window.__cuedFreeSealer) return;
  window.__cuedFreeSealer = true;

  var GIFT_VARIANT = 59651953918284;      // SEALER (Gratis) – Transparent, 0 EUR
  var OLD_GIFT_VARIANT = 55828706689356;  // v2: normaler Sealer mit Property _cued_gratis
  var GIFT_PROP = '_cued_gratis';
  var TRIGGER_PRODUCTS = [
    15028460552524, 15747293118796, 15967181537612, 15967192973644, 15967203361100,
    15967238652236, 15967316312396, 15967319359820, 16125390422348, 16125391241548,
    16125392093516
  ];

  // ---------------------------------------------------------------------------
  // v4: Landingpages. Die LPs schicken direkt per Warenkorb-Permalink
  // (/cart/<variante>:<menge>,...?discount=...) in den Checkout – dort laeuft dieses
  // Skript nicht mehr. Deshalb wird die Navigation abgefangen und der Gratis-Sealer
  // an den Link gehaengt, sobald ein Starterkit oder die Toolbox darin enthalten ist.
  var TRIGGER_VARIANTS = [
    53110128542028, // TOOLBOX
    57490996429132, 58341947048268, 58341970116940, 58341994889548, 58342075531596,
    58342887948620, 58342909968716, // Starterkits schwarz
    58890224828748, 58890229252428, 58890234298700 // Starterkits Burgundy
  ];

  function permalinkWithGift(href) {
    try {
      var u = new URL(href, location.href);
      if (u.hostname.replace(/^www\./, '') !== location.hostname.replace(/^www\./, '')) return null;
      var m = u.pathname.match(/^(.*\/cart\/)(\d+:\d+(?:,\d+:\d+)*)\/?$/);
      if (!m) return null;
      var hasTrigger = false, hasGift = false;
      m[2].split(',').forEach(function (line) {
        var id = parseInt(line.split(':')[0], 10), qty = parseInt(line.split(':')[1], 10);
        if (qty > 0 && TRIGGER_VARIANTS.indexOf(id) !== -1) hasTrigger = true;
        if (id === GIFT_VARIANT) hasGift = true;
      });
      if (!hasTrigger || hasGift) return null;
      u.pathname = m[1] + m[2] + ',' + GIFT_VARIANT + ':1';
      return u.href;
    } catch (e) { return null; }
  }
  window.cuedPermalinkWithGift = permalinkWithGift;

  // Navigation API (Chrome/Edge, Safari ab 26.2, Firefox ab 147)
  if (window.navigation && typeof window.navigation.addEventListener === 'function') {
    window.navigation.addEventListener('navigate', function (e) {
      if (!e.cancelable || e.hashChange || e.navigationType === 'traverse' || e.navigationType === 'reload') return;
      var next = permalinkWithGift(e.destination && e.destination.url);
      if (!next) return;
      e.preventDefault();
      setTimeout(function () { location.href = next; }, 0);
    });
  }

  // Links/Buttons mit Permalink im href (alle Browser)
  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest && e.target.closest('a[href*="/cart/"]');
    if (!a) return;
    var next = permalinkWithGift(a.href);
    if (next) a.href = next;
  }, true);

  var origFetch = window.fetch.bind(window);
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root || '/').replace(/\/$/, '');
  var busy = false, again = false, timer = null, failures = 0;

  function isCartMutation(url) {
    return /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(url || '');
  }

  function json(url, body) {
    var opts = { headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' } };
    if (body) {
      opts.method = 'POST';
      opts.headers['Content-Type'] = 'application/json';
      opts.body = JSON.stringify(body);
    }
    return origFetch(root + url, opts).then(function (r) {
      return r.json().then(function (d) { if (!r.ok) throw d; return d; });
    });
  }

  function refreshUi(cart) {
    if (/\/cart\/?$/.test(location.pathname)) { location.reload(); return; }
    if (typeof window.upcartRefreshCart === 'function') { try { window.upcartRefreshCart(); } catch (e) {} }
    renderDrawer(cart);
    // zweiter Durchlauf: falls Theme/Upsell-App den Drawer danach noch mit altem Stand rendert
    setTimeout(function () { renderDrawer(cart); }, 1500);
  }

  function renderDrawer(cart) {
    var ids = ['cart-drawer', 'cart-icon-bubble'];
    // Startseite + kein Accept-JSON-Header, sonst liefert eine Produkt-URL das Produkt-JSON statt der Sections
    origFetch(root + '/?sections=' + ids.join(','), { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        var parser = new DOMParser();
        ids.forEach(function (id) {
          if (!sections[id]) return;
          var doc = parser.parseFromString(sections[id], 'text/html');
          if (id === 'cart-drawer') {
            var src = doc.querySelector('#CartDrawer'), dst = document.querySelector('#CartDrawer');
            if (src && dst) dst.innerHTML = src.innerHTML;
            var drawer = document.querySelector('cart-drawer');
            if (drawer) drawer.classList.toggle('is-empty', cart.item_count === 0);
          } else {
            var s = doc.querySelector('.shopify-section'), d = document.getElementById(id);
            if (s && d) d.innerHTML = s.innerHTML;
          }
        });
        document.querySelectorAll('.cart-count-bubble span:first-child, [data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
        });
      })
      .catch(function () {});
  }

  function sync() {
    if (busy) { again = true; return; }
    if (failures >= 3) return;
    busy = true;

    json('/cart.js').then(function (cart) {
      var triggers = 0, giftLines = [], oldGiftLines = [];
      cart.items.forEach(function (it) {
        if (TRIGGER_PRODUCTS.indexOf(it.product_id) !== -1) triggers += it.quantity;
        if (it.variant_id === GIFT_VARIANT) giftLines.push(it);
        if (it.variant_id === OLD_GIFT_VARIANT && it.properties && it.properties[GIFT_PROP]) oldGiftLines.push(it);
      });

      var updates = {}, changed = false;
      // alte v2-Gratiszeilen (normaler Sealer) entfernen
      oldGiftLines.forEach(function (l) { updates[l.key] = 0; changed = true; });

      if (triggers > 0) {
        // genau 1 Gratis-Sealer
        giftLines.forEach(function (l, i) {
          var want = i === 0 ? 1 : 0;
          if (l.quantity !== want) { updates[l.key] = want; changed = true; }
        });
      } else {
        giftLines.forEach(function (l) { updates[l.key] = 0; changed = true; });
      }

      var p = changed ? json('/cart/update.js', { updates: updates }) : Promise.resolve();

      if (triggers > 0 && !giftLines.length) {
        p = p.then(function () {
          var props = {}; props[GIFT_PROP] = '1';
          return json('/cart/add.js', { items: [{ id: GIFT_VARIANT, quantity: 1, properties: props }] });
        });
        changed = true;
      }

      if (changed) {
        return p.then(function () { return json('/cart.js'); }).then(refreshUi);
      }
    }).catch(function (e) {
      failures++;
      console.warn('cued free sealer:', e);
    }).then(function () {
      busy = false;
      if (again) { again = false; schedule(); }
    });
  }

  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(sync, 350);
  }

  // Jede Warenkorb-Aenderung (Theme, Quick-Buy, Upsell-Apps) abfangen
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || String(input || '');
    var p = origFetch(input, init);
    if (isCartMutation(url)) p.then(schedule, function () {});
    return p;
  };

  var origOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    if (isCartMutation(String(url))) this.addEventListener('load', schedule);
    return origOpen.apply(this, arguments);
  };

  document.addEventListener('cart:updated', schedule);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sync);
  else sync();
})();
